module.exports = __webpack_public_path__ + "static/media/logo_white.e3955d98.svg";